import { buildSchoolEventChunks } from './importLogsParsingChunks';
import {
  isLongNoteEmailText,
  looksLikeCaregiverTimelineImportText,
  normalizeNaturalCaptureChunkText,
  splitNaturalCaptureLongNoteBlocks,
} from './naturalCapturePasteRouting';
export {
  isLongNoteEmailText,
  looksLikeCaregiverTimelineImportText,
  normalizeNaturalCaptureChunkText,
  shouldRerouteQuickCaptureNarrativeToImportReview,
  shouldUseImportedNarrativeReviewText,
  splitNaturalCaptureLongNoteBlocks,
  stripNaturalCaptureEmailBoilerplate,
} from './naturalCapturePasteRouting';

const resolveInputShape = (text = '', {
  inputShape = '',
  adapterMode = '',
  parserMode = '',
  sourceMode = '',
  inputMode = '',
} = {}) => {
  if (inputShape === 'school_text' || inputShape === 'long_note_email') {
    return inputShape;
  }

  if (
    adapterMode === 'school_pasted_text'
    || parserMode === 'school_text'
    || sourceMode === 'school_text'
    || inputMode === 'school_pasted_text'
  ) {
    return 'school_text';
  }

  if (
    adapterMode === 'long_note_email'
    || parserMode === 'long_note_email'
    || sourceMode === 'long_note_email'
    || inputMode === 'long_note_email'
  ) {
    return 'long_note_email';
  }

  if (
    adapterMode === 'imported_file_text'
    || parserMode === 'file_import_text'
    || sourceMode === 'docx_xlsx'
    || inputMode === 'file_import'
  ) {
    if (looksLikeCaregiverTimelineImportText(text)) {
      return 'school_text';
    }
    return isLongNoteEmailText(text) ? 'long_note_email' : 'school_text';
  }

  return isLongNoteEmailText(text) ? 'long_note_email' : 'school_text';
};

export const detectNaturalCaptureInputShape = (text = '', options = {}) => resolveInputShape(normalizeNaturalCaptureChunkText(text), options);

export const buildNaturalCaptureChunkPlan = (text = '', options = {}) => {
  const normalizedText = normalizeNaturalCaptureChunkText(text);
  const inputShape = resolveInputShape(normalizedText, options);
  const plan = {
    normalizedText,
    inputShape,
    blocks: [],
    chunks: [],
    chunkerUsed: null,
  };

  if (!normalizedText) {
    return plan;
  }

  if (inputShape === 'long_note_email') {
    plan.blocks = splitNaturalCaptureLongNoteBlocks(normalizedText);
    plan.chunkerUsed = 'splitNaturalCaptureLongNoteBlocks';
    return plan;
  }

  plan.chunks = buildSchoolEventChunks(normalizedText);
  plan.chunkerUsed = 'buildSchoolEventChunks';
  return plan;
};
